import { usePhone } from '../shell/softphoneContext';

/**
 * Where the far end of a call comes out.
 *
 * One element for the life of the console, rendered by the shell rather than by whichever
 * card is showing the call: swapping the stream on an existing element keeps the speaker
 * the dispatcher chose, and creating a new one per call does not. A view change must not
 * create one at all, which is the reason it is up here and not in the telephone card.
 */
export function FarEnd() {
  const { audio } = usePhone();

  return <audio ref={audio} autoPlay />;
}
